export type { InfoListItemProps } from "./info-list-item";
export { InfoListItem } from "./info-list-item";
